import { howSteps } from "@/data/siteContent";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck } from "lucide-react";
import { HOWITWORKS } from "@/constants/testIds";

export const HowItWorks = () => {
  return (
    <section id="come-funziona" data-testid={HOWITWORKS.section} className="py-16 sm:py-24 section-tint border-y border-border">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <p className="text-sm font-semibold text-accent uppercase tracking-wider">Come funziona</p>
          <h2 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight">Attivo in 3 semplici passi</h2>
          <p className="mt-4 text-muted-foreground text-base leading-relaxed">
            Dall'acquisto alla protezione della famiglia in pochi minuti. Nessuna competenza tecnica richiesta.
          </p>
        </Reveal>

        <StaggerGroup className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 relative">
          {howSteps.map((s) => (
            <StaggerItem key={s.n}>
              <div className="relative h-full rounded-2xl border border-border bg-card p-7 card-lift glow-hover">
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground glow">
                    <s.icon className="h-6 w-6" />
                  </span>
                  <span className="font-display text-4xl font-semibold text-muted-foreground/30">{s.n}</span>
                </div>
                <h3 className="mt-5 text-xl font-semibold">{s.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <Reveal delay={0.1} className="mt-6">
          <div data-testid="transparency-box" className="relative overflow-hidden rounded-2xl border-2 border-accent bg-card p-6 sm:p-8 glow-strong">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-accent glow">
                <ShieldCheck className="h-7 w-7" />
              </span>
              <div>
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-xl sm:text-2xl font-semibold">Trasparenza e consenso</h3>
                  <Badge className="rounded-md bg-accent text-accent-foreground">Uso responsabile</Badge>
                </div>
                <p className="mt-2 text-muted-foreground leading-relaxed max-w-3xl">
                  controllatelefoni.it è progettato per il controllo parentale sui minori sotto la tua tutela e per il
                  monitoraggio di dispositivi di tua proprietà. L'utilizzo su un adulto richiede sempre il suo consenso
                  esplicito: è vietato ogni uso occulto o non autorizzato. La trasparenza tutela te e le persone a te vicine.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
